export const COLUMN_TYPE = {
  PERCENTAGE: 0,
  NUMBER: 1,
  INCLUDES: 2,
  TIME: 3,
  DATE: 4,
  TIME_FROM_NOW: 5,
  OPEN: 6,
  UNKNOWN: 7
};

export const OPERATION_TYPE = {
  RANGE: 0,
  INCLUDES: 1,
  OPEN: 2
};
